module.exports = __webpack_public_path__ + "app/img/toolBG.2a5826f9.jpg";